import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function HeaderTW({ user, onSignOut, setCurrentPage }) {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();

  const goHomeAnd = (pageKey) => {
    if (loc.pathname !== "/") nav("/");
    setCurrentPage?.(pageKey);
    setOpen(false);
  };

  const authClick = async () => {
    if (user) {
      await onSignOut?.();
      goHomeAnd("home");
    } else {
      goHomeAnd("auth");
    }
  };

  const TopLinkBtn = ({ children, onClick }) => (
    <button
      type="button"
      onClick={onClick}
      /*className="tw-bg-transparent tw-border-0 tw-appearance-none tw-p-0 tw-m-0 tw-font-inherit tw-text-slate-600 hover:tw-text-slate-900 tw-cursor-pointer"*/
	  className="tw-bg-transparent tw-border-0 tw-appearance-none tw-p-0 tw-m-0 tw-font-inherit tw-cursor-pointer tw-text-slate-600 hover:tw-text-blue-600"

    >
      {children}
    </button>
  );
  
  const goMap = () => {
  setOpen(false);
  nav("/terkep");
};

  return (
    <header className="tw-sticky tw-top-0 tw-z-50 tw-bg-white/80 tw-backdrop-blur tw-border-b tw-border-slate-200">
      <div className="tw-mx-auto tw-max-w-6xl tw-px-4 tw-py-3 tw-flex tw-items-center tw-justify-between">
        {/* Brand */}
        <button
          type="button"
          onClick={() => goHomeAnd("home")}
          className="tw-bg-transparent tw-border-0 tw-appearance-none tw-p-0 tw-m-0 tw-flex tw-items-center tw-gap-3 tw-text-slate-900 tw-cursor-pointer"
        >
          <img
            src={process.env.PUBLIC_URL + "/logo512.png"}
            alt="Lelkigyakorlat-kereső"
            className="tw-h-10 tw-w-10 tw-rounded-xl tw-object-contain"
          />
          <span className="tw-font-semibold">Lelkigyakorlat-kereső</span>
        </button>

        {/* Desktop nav */}
        <nav className="tw-hidden md:tw-flex tw-items-center tw-gap-8">
          <TopLinkBtn onClick={() => goHomeAnd("about")}>Az oldal célja</TopLinkBtn>
          <TopLinkBtn onClick={() => goHomeAnd("contact")}>Kapcsolat</TopLinkBtn>
		  <TopLinkBtn onClick={goMap}>Térkép</TopLinkBtn>
		  
       { /*  <Link to="/terkep" className="tw-bg-transparent tw-border-0 tw-appearance-none tw-p-0 tw-m-0 tw-font-inherit tw-cursor-pointer tw-text-slate-600 hover:tw-text-blue-600">
            Térkép
          </Link>*/}
		{user && (
			  <button
				type="button"
				onClick={() => goHomeAnd("addEvent")}
				className="tw-border-0 tw-appearance-none tw-rounded-xl tw-bg-emerald-600 tw-px-4 tw-py-2 tw-text-white tw-font-medium hover:tw-bg-emerald-700"
			  >
				Lelkigyakorlat hozzáadása
			  </button>
			)}


          <button
            type="button"
            onClick={authClick}
            className="tw-border-0 tw-appearance-none tw-rounded-xl tw-bg-blue-600 tw-px-4 tw-py-2 tw-text-white tw-font-medium hover:tw-bg-blue-700"
          >
            {user ? "Kilépés" : "Belépés"}
          </button>
        </nav>

        {/* Mobile menu button */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="md:tw-hidden tw-border-0 tw-appearance-none tw-inline-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-xl tw-bg-blue-600 tw-text-white hover:tw-bg-blue-700"
          aria-label="Menü"
          aria-expanded={open}
        >
          ☰
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="md:tw-hidden tw-border-t tw-border-slate-200 tw-bg-white">
          <div className="tw-mx-auto tw-max-w-6xl tw-px-4 tw-py-3 tw-flex tw-flex-col tw-gap-2">
            <button
              type="button"
              onClick={() => goHomeAnd("about")}
              className="tw-bg-transparent tw-border-0 tw-appearance-none tw-text-left tw-rounded-lg tw-px-3 tw-py-2 hover:tw-bg-slate-50"
            >
              Az oldal célja
            </button>
            <button
              type="button"
              onClick={() => goHomeAnd("contact")}
              className="tw-bg-transparent tw-border-0 tw-appearance-none tw-text-left tw-rounded-lg tw-px-3 tw-py-2 hover:tw-bg-slate-50"
            >
              Kapcsolat
            </button>
            <Link
              to="/terkep"
              onClick={() => setOpen(false)}
              className="tw-rounded-lg tw-px-3 tw-py-2 hover:tw-bg-slate-50 tw-no-underline tw-text-slate-900"
            >
              Térkép
            </Link>
			{user && (
			  <button
				type="button"
				onClick={() => goHomeAnd("addEvent")}
				className="tw-mt-2 tw-border-0 tw-appearance-none tw-rounded-xl tw-bg-emerald-600 tw-px-4 tw-py-2 tw-text-white tw-font-medium hover:tw-bg-emerald-700"
			  >
				Lelkigyakorlat hozzáadása
			  </button>
			)}

            <button
              type="button"
              onClick={authClick}
              className="tw-mt-2 tw-border-0 tw-appearance-none tw-rounded-xl tw-bg-blue-600 tw-px-4 tw-py-2 tw-text-white tw-font-medium hover:tw-bg-blue-700"
            >
              {user ? "Kilépés" : "Belépés"}
            </button>
          </div>
        </div>
      )}
    </header>
  );
}

